import mixpanel, { Dict } from "mixpanel-browser";

export const sendMixpanelData = (eventName: string, data: Dict | undefined) => {
  mixpanel.init(import.meta.env.VITE_MIXPANEL ?? "");
  mixpanel.track(eventName, { ...data, app: "reef" });
};
